import get from "lodash/get";

export const customerAuthenticationOccurred = (
  prevPropsData: Record<string, unknown>,
  nextPropsData: Record<string, unknown>
) => {
  return (
    !get(prevPropsData, "customer.authenticated", false) &&
    get(nextPropsData, "customer.authenticated", false)
  );
};

export const customerLogOutOccurred = (
  prevPropsData: Record<string, unknown>,
  nextPropsData: Record<string, unknown>
) => {
  return (
    get(prevPropsData, "customer.authenticated", false) &&
    !get(nextPropsData, "customer.authenticated", false)
  );
};

export const customerEmailChanged = (
  prevPropsData: Record<string, unknown>,
  nextPropsData: Record<string, unknown>
) => {
  return (
    get(prevPropsData, "customer.email", "") !==
    get(nextPropsData, "customer.email", "")
  );
};

export const customerIsAuthenticated = (data: Record<string, unknown>) =>
  get(data, "customer.authenticated", false);
